import { rootApi } from 'root-api'

// Duplicated from apps/publisher/src/javascripts/features/contacts/api.js
// to resolve a short-term dependency cycle that should be resolved with
// the introduction of the shared right rail component.
const api = rootApi.enhanceEndpoints({ addTagTypes: ['CONTACTS-SEARCH-SFC'] }).injectEndpoints({
  endpoints: (build) => ({
    searchContactsSfc: build.query({
      query: (query) => ({
        url: '/api/dashboard/contacts/search',
        params: { query, with_events: false }
      }),
      providesTags: ['CONTACTS-SEARCH-SFC']
    }),
  })
})

export const {
  useSearchContactsSfcQuery,
} = api
